export default "__VITE_ASSET__DMLShZ9F__"